import React from 'react';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { oktaAuth } from 'auth';
import { toRelativeUrl } from '@okta/okta-auth-js';
import LockIcon from '@material-ui/icons/Lock';
import IconButton from '@material-ui/core/IconButton';

const ConnectionChip = ({ classes, connectionState, inHeader, isMobile }) => {
  // const { oktaAuth } = useOktaAuth();
  const getClass = () => {
    switch (connectionState) {
      case 'connected':
        return classes.connectionChip;
      default:
        return classes.connectionChipError;
    }
  }
  const getLabel = () => {
    if (inHeader) { // For header, only show "Session expired. Please Relogin"
      switch (connectionState) {
        case 'expired':
          return 'Session Expired. Click to relogin';
        default:
          return null;
      }
    } else {
      switch (connectionState) {
        case 'connected':
          return 'Connected';
        case 'disconnected':
          return "Disconnected";
        case 'unauthorizedDisconnected':
          return "Disconnected";
        case 'expired':
          return "Session Expired. Click to relogin"
        default:
          return null;
      }
    }
  }
  const clickHandler = () => {
    const originalUri = toRelativeUrl(window.location.href, window.location.origin);
    oktaAuth.setOriginalUri(originalUri);
    oktaAuth.signInWithRedirect()
  }
  return (
    getLabel() && (
            connectionState === 'expired'
            ?
            (isMobile ? <IconButton style={{color: "red"}} onClick={clickHandler}><LockIcon /></IconButton> : <Chip className={getClass()} label={getLabel()} onClick={clickHandler} />)            
            : 
            <Chip className={getClass()} label={getLabel()} />
              )
  );
};

const styles = theme => ({
  connectionChip: {
    height: 18,
    color: '#fff',
    'background-color': theme.palette.secondary.main,
    'margin-right': '1em'
  },
  connectionChipError: {
    height: 18,
    color: '#fff',
    'background-color': theme.palette.red.main,
    'margin-right': '1em'
  }
});

const mapStateToProps = state => ({
  connectionState: state.appState.connectionState,
  isMobile: state.appState.isMobile,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(ConnectionChip);
